import { ITableColumnMetadata } from '../../components/CustomTable/interfaces';

const tableColumnMetadata: ITableColumnMetadata[] = [
  {
    key: 'name',
    displayName: 'Formulario'
  },
  {
    key: 'description',
    displayName: 'Descripción',
    type: 'truncate'
  },
  {
    key: 'url',
    displayName: 'URL',
    type: 'url'
  },
  {
    key: 'creationDate',
    displayName: 'Fecha de creación',
    type: 'datetime'
  }
];

export default tableColumnMetadata;
